import { createAtomObserver } from '@exodus/atoms';
import type { Definition } from '@exodus/dependency-types';
import type Emitter from '@exodus/wild-emitter';

import type { InstallCalloutVisibleAtom } from './atoms/install-callout-visible.js';
import type { InstallModalVisibleAtom } from './atoms/install-modal-visible.js';

type Dependencies = {
  installModalVisibleAtom: InstallModalVisibleAtom;
  installCalloutVisibleAtom: InstallCalloutVisibleAtom;
  port: Emitter;
};

export const INSTALL_MODAL_VISIBLE_EVENT = 'installModalVisible';
export const INSTALL_CALLOUT_VISIBLE_EVENT = 'installCalloutVisible';

const pwaPluginDefinition = {
  id: 'pwaPlugin',
  type: 'plugin',
  factory: ({
    installModalVisibleAtom,
    installCalloutVisibleAtom,
    port,
  }: Dependencies) => {
    const observers = [
      createAtomObserver({
        atom: installModalVisibleAtom,
        port,
        event: INSTALL_MODAL_VISIBLE_EVENT,
      }),
      createAtomObserver({
        atom: installCalloutVisibleAtom,
        port,
        event: INSTALL_CALLOUT_VISIBLE_EVENT,
      }),
    ];

    observers.forEach((observer) => observer.register());

    return {
      onLoad: () => {
        observers.forEach((observer) => observer.start());
      },
      onStop: () => {
        observers.forEach((observer) => observer.unregister());
      },
      onClear: async () => {
        await installModalVisibleAtom.reset();
        await installCalloutVisibleAtom.reset();
      },
    };
  },
  dependencies: [
    'port',
    'installModalVisibleAtom',
    'installCalloutVisibleAtom',
  ],
} as const satisfies Definition;

export default pwaPluginDefinition;
